<template>
    <div class = "portal" v-bind:class="adminClass" v-on:click="selectPortal">
        <div class = "portal-logo">
            <img v-bind:src="portal.logo" v-if="portal.logo.length > 0"/>
            <img src = "../../assets/go1-learn-white.png" v-if="portal.logo.length === 0"/>
        </div>
        <div class = "portal-text-content">
            <div v-if="requiresAdmin && !portal.is_admin" class = "no-admin-badge">
                No admin access
            </div>
            <br>
            <div class = "portal-info">
                <h4>
                    {{portal.name}}
                </h4>
                <p class = "info-context">
                    {{portal.url}}
                </p>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: ['portal'],

    computed: {
        requiresAdmin () {
            return this.$store.state.admin_login_only;
        },

        // compute whether the user is a admin on this portal
        adminClass () {
            return {
                'disabled': this.requiresAdmin && !this.portal.is_admin
            }
        }
    },

    methods: {
        // route to the portal auth page for the selected portal
        selectPortal () {
            if (this.portal.is_admin || !this.requiresAdmin) {
                this.$router.push({
                  name: 'portal_auth',
                  params: {
                    portal_id: this.portal.id,
                    portal_name: this.portal.name,
                    portal_url: this.portal.url
                  }
                });
            }
        }
    }
}
</script>

<style scoped>
    .portal{
        border: 1px solid #D4DEE5;
        border-radius: 10px;
        height: 130px;
        margin-bottom: 16px;
        display: flex;
        cursor: pointer;
    }
    .portal-text-content{
        width: 70%;
        text-align: left;
        height: 120px;
        overflow-y: hidden;
        padding-top: 10px;
        padding-left: 30px;
        overflow-wrap: break-word;
        padding-right: 30px;
    }
    .portal-logo{
        width: 30%;
        background-color: #5887B1;
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .portal-logo img{
        max-height: 100%;
        max-width: 100%;
    }
    .portal.disabled{
        cursor: initial;
    }

    .portal.disabled .portal-logo, .portal.disabled .portal-info{
        opacity: 0.7;
    }
    .no-admin-badge{
        background: #DFEBF1;
        border: 1px solid #DFEBF1;
        border-radius: 20px;
        display: inline-block;
        padding-left: 10px;
        padding-right: 10px;
        opacity: 1 !important;
    }
    h4{
        font-weight: bold;
    }
    .info-context{
        color: #667276;
        font-weight: bold;
    }
</style>



// WEBPACK FOOTER //
// src/components/Portal/Portal.vue